export interface ISpecialtyStatic {
  title: string;
  tag: string;
  isTopSelection: boolean;
}

export const ADDICTION: ISpecialtyStatic = {
  title: 'Addiction',
  tag: 'addiction',
  isTopSelection: true
};

export const ADHD: ISpecialtyStatic = {
  title: 'ADHD',
  tag: 'adhd',
  isTopSelection: true
};

export const TEENS: ISpecialtyStatic = {
  title: 'Teens',
  tag: 'adolescentTeenMentalHealth',
  isTopSelection: true
};

export const ANGER_MANAGEMENT: ISpecialtyStatic = {
  title: 'Anger Management',
  tag: 'angerManagement',
  isTopSelection: true
};

export const ANTISOCIAL_BEHAVIOR: ISpecialtyStatic = {
  title: 'Antisocial Behavior',
  tag: 'antisocialDisorders',
  isTopSelection: false
};

export const ANXIETY: ISpecialtyStatic = {
  title: 'Anxiety',
  tag: 'anxiety',
  isTopSelection: true
};

export const AUTISM_SPECTRUM: ISpecialtyStatic = {
  title: 'Autism Spectrum',
  tag: 'autismSpectrumSupport',
  isTopSelection: false
};

export const BIPOLAR_DISORDER: ISpecialtyStatic = {
  title: 'Bipolar Disorder',
  tag: 'bipolarDisorder',
  isTopSelection: true
};

export const BORDERLINE_PERSONALITY: ISpecialtyStatic = {
  title: 'Borderline Personality',
  tag: 'borderlinePersonalityDisorder',
  isTopSelection: false
};

export const CHILDREN: ISpecialtyStatic = {
  title: 'Children',
  tag: 'childrenMentalHealth',
  isTopSelection: false
};

export const DEMENTIA: ISpecialtyStatic = {
  title: 'Dementia',
  tag: 'dementia',
  isTopSelection: false
};

export const DEPRESSION: ISpecialtyStatic = {
  title: 'Depression',
  tag: 'depression',
  isTopSelection: true
};

export const DEVELOPMENTAL_DISABILITIES: ISpecialtyStatic = {
  title: 'Developmental Disabilities',
  tag: 'developmentalDisabilities',
  isTopSelection: false
};

export const DISSOCIATIVE_DISORDERS: ISpecialtyStatic = {
  title: 'Dissociative Disorders',
  tag: 'dissociativeDisorders',
  isTopSelection: false
};

export const EATING_DISORDERS: ISpecialtyStatic = {
  title: 'Eating Disorders',
  tag: 'eatingDisorders',
  isTopSelection: false
};

export const FAMILY_RELATIONSHIPS: ISpecialtyStatic = {
  title: 'Family Relationships',
  tag: 'familyRelationships',
  isTopSelection: true
};

export const GENDER_IDENTITY: ISpecialtyStatic = {
  title: 'Gender Identity',
  tag: 'genderIdentity',
  isTopSelection: false
};

export const GRIEF_BEREAVEMENT: ISpecialtyStatic = {
  title: 'Grief / Bereavement',
  tag: 'griefBereavement',
  isTopSelection: true
};

export const INTIMATE_ROMANTIC_RELATIONSHIPS: ISpecialtyStatic = {
  title: 'Intimate / Romantic Relationships',
  tag: 'intimateRomanticRelationships',
  isTopSelection: true
};

export const LEARNING_DISORDERS: ISpecialtyStatic = {
  title: 'Learning Disorders',
  tag: 'learningDisorders',
  isTopSelection: false
};

export const LGBTQIA_SUPPORT: ISpecialtyStatic = {
  title: 'LGBTQIA+ Support',
  tag: 'lgbtqiaSupport',
  isTopSelection: false
};

export const LIFE_TRANSITIONS: ISpecialtyStatic = {
  title: 'Life Transitions',
  tag: 'lifeTransitions',
  isTopSelection: true
};

export const PHYSICAL_HEALTH: ISpecialtyStatic = {
  title: 'Physical Health',
  tag: 'medicalPhysicalHealth',
  isTopSelection: false
};

export const MILITARY_VETERAN_SUPPORT: ISpecialtyStatic = {
  title: 'Military / Veteran Support',
  tag: 'militaryVeteranSupport',
  isTopSelection: false
};

export const MULTICULTURAL_DIVERSITY: ISpecialtyStatic = {
  title: 'Multicultural / Diversity Issues',
  tag: 'multiculturalDiversity',
  isTopSelection: false
};

export const NARCISSISTIC_PERSONALITY: ISpecialtyStatic = {
  title: 'Narcissistic Personality',
  tag: 'narcissisticPersonalityDisorder',
  isTopSelection: false
};

export const OCD: ISpecialtyStatic = {
  title: 'OCD (Obsessive-Compulsive)',
  tag: 'ocd',
  isTopSelection: false
};

export const PREGNANCY_PRENATAL_POSTPARTUM: ISpecialtyStatic = {
  title: 'Pregnancy, Prenatal, Postpartum',
  tag: 'perinatalSupport',
  isTopSelection: false
};

export const PHOBIAS: ISpecialtyStatic = {
  title: 'Phobias',
  tag: 'phobias',
  isTopSelection: false
};

export const PSYCHOSIS_SCHIZOPHRENIA: ISpecialtyStatic = {
  title: 'Psychosis / Schizophrenia',
  tag: 'psychosisSchizophrenia',
  isTopSelection: false
};

export const PTSD: ISpecialtyStatic = {
  title: 'PTSD',
  tag: 'ptsd',
  isTopSelection: true
};

export const SEX_INTIMACY_ISSUES: ISpecialtyStatic = {
  title: 'Sex / Intimacy Issues',
  tag: 'sexIntimacyIssues',
  isTopSelection: false
};

export const SLEEP_DISORDERS: ISpecialtyStatic = {
  title: 'Sleep Disorders',
  tag: 'sleepDisorders',
  isTopSelection: false
};

export const SOMATIC_SYMPTOMS: ISpecialtyStatic = {
  title: 'Somatic Symptoms',
  tag: 'somaticSymptomDisorder',
  isTopSelection: false
};

export const SPIRITUALITY: ISpecialtyStatic = {
  title: 'Spirituality',
  tag: 'spirituality',
  isTopSelection: true
};

export const STRESS: ISpecialtyStatic = {
  title: 'Stress',
  tag: 'stress',
  isTopSelection: true
};

export const SELF_HARM_AND_SUICIDAL_FEELINGS: ISpecialtyStatic = {
  title: 'Self-harm and Suicidal Feelings',
  tag: 'selfHarmSuicideIdeation',
  isTopSelection: true
};

export const TRAUMA: ISpecialtyStatic = {
  title: 'Trauma',
  tag: 'trauma',
  isTopSelection: true
};

export const TRAUMATIC_BRAIN_INJURY: ISpecialtyStatic = {
  title: 'Traumatic Brain Injury',
  tag: 'traumaticBrainInjury',
  isTopSelection: false
};

export const SPECIALTY_LIST: ISpecialtyStatic[] = [
  ADDICTION,
  ADHD,
  TEENS,
  ANGER_MANAGEMENT,
  ANTISOCIAL_BEHAVIOR,
  ANXIETY,
  AUTISM_SPECTRUM,
  BIPOLAR_DISORDER,
  BORDERLINE_PERSONALITY,
  CHILDREN,
  DEMENTIA,
  DEPRESSION,
  DEVELOPMENTAL_DISABILITIES,
  DISSOCIATIVE_DISORDERS,
  EATING_DISORDERS,
  FAMILY_RELATIONSHIPS,
  GENDER_IDENTITY,
  GRIEF_BEREAVEMENT,
  INTIMATE_ROMANTIC_RELATIONSHIPS,
  LEARNING_DISORDERS,
  LGBTQIA_SUPPORT,
  LIFE_TRANSITIONS,
  PHYSICAL_HEALTH,
  MILITARY_VETERAN_SUPPORT,
  MULTICULTURAL_DIVERSITY,
  NARCISSISTIC_PERSONALITY,
  OCD,
  PREGNANCY_PRENATAL_POSTPARTUM,
  PHOBIAS,
  PSYCHOSIS_SCHIZOPHRENIA,
  PTSD,
  SEX_INTIMACY_ISSUES,
  SLEEP_DISORDERS,
  SOMATIC_SYMPTOMS,
  SPIRITUALITY,
  STRESS,
  SELF_HARM_AND_SUICIDAL_FEELINGS,
  TRAUMA,
  TRAUMATIC_BRAIN_INJURY
];
